module.exports = __webpack_public_path__ + "img/sv117.266f9fcb.svg";